"use client"

import { Sparkles, ArrowRight, ExternalLink } from "lucide-react"
import { useAuth } from "../context/AuthContext";
import { dictionary } from "../utils/dictionary";

const FluxiFlow = "/assets/images/fluxi-flow.jpeg";

interface WelcomeModalProps {
  isOpen: boolean
  onStart: () => void
  onClose: () => void
}

export default function WelcomeModal({ isOpen, onStart, onClose }: WelcomeModalProps) {
  if (!isOpen) return null
  const { language } = useAuth();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-gradient-to-br from-blue-500/20 via-blue-500/20 to-blue-500/20 backdrop-blur-sm"
      // onClick={onClose}
      />

      <div className="relative bg-white rounded-[24px] shadow-2xl max-w-[600px] w-full transform transition-all">
        {/* <button
          onClick={onClose}
          className="absolute top-5 right-5 text-gray-300 hover:text-gray-500 transition-colors z-10"
          aria-label="Cerrar"
        >
          <X size={20} strokeWidth={2} />
        </button> */}

        <div className="flex items-center gap-6 p-8">
          <div className="flex-shrink-0">
            <div className="w-48 h-48 flex items-center justify-center">
              <img src={FluxiFlow} alt="Logo" className="w-full h-full object-contain" />
            </div>
          </div>

          <div className="flex-1 space-y-5">
            <div>
              <p className="text-gray-500 text-sm mb-1">{dictionary["hello"][language]},</p>
              <h2 className="text-3xl font-bold text-gray-900 leading-tight">{dictionary["help-me-create-your-first-page"][language]}</h2>
            </div>

            <button
              onClick={onStart}
              className="w-full bg-fluxi hover:bg-fluxi-dark text-white font-semibold text-base py-3.5 px-6 rounded-xl transition-all flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
            >
              <Sparkles className="w-5 h-5" />
              {dictionary["let's-start"][language]}
              <ArrowRight className="w-5 h-5" />
            </button>

            <div className="text-center">
              <p className="text-gray-500 text-sm">
                {dictionary["do-you-prefer-to-see-the-training-first"]?.[language] || "¿Prefieres ver el entrenamiento primero?"}
              </p>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    import.meta.env.VITE_URL_TRAINING,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
                className="mt-1 inline-flex items-center justify-center gap-2 text-fluxi hover:text-fluxi-dark font-semibold"
              >
                {dictionary["go-to-training"][language] || "Ir al entrenamiento de Fluxi"} <ExternalLink className="w-4 h-4" />
              </a>
            </div>

            {/* <button
              onClick={onClose}
              className="w-full text-gray-400 hover:text-gray-600 font-medium text-sm py-1 transition-colors"
            >
              Saltar tutorial
            </button> */}
          </div>
        </div>
      </div>
    </div>
  )
}
